import { Api } from "../config/request";

export default {
  getOrdersList(queryParams) {
    return Api.post(`/orders`, queryParams);
  },
  getOrdersDetails(id) {
    return Api.get(`/orders/${id}`);
  },
  forceComplete(id, data) {
    return Api.post(`/orders/${id}/force-complete`, data);
  },
  cancel(id, data) {
    return Api.post(`/orders/${id}/cancel`, data);
  },
  markOrderReady(id, data) {
    return Api.post(`/orders/${id}/mark-order-ready`, data);
  },
  reAssign(id, data) {
    return Api.post(`/orders/${id}/re-assign`, data);
  },
  unAssign(id, data) {
    return Api.post(`/orders/${id}/un-assign`, data);
  },
  getActionTypesWithReasons(id) {
    return Api.get(`/orders/${id}/actions`);
  },
};
